export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fe32eed4ed2c841235146cd3206a38609e2b2b361&name=fetchTypeahead!'